module.exports = __webpack_public_path__ + "catalog/items/outdoor/sunlounger/sunlounger.svg";